module.exports = __webpack_public_path__ + "static/media/time-session-9h.96faf9b5.svg";